//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { plusIcon, minusIcon } from '~/static/icons/index';
export default {
    name: 'FaqAccordion',
    props: {
        cardDetails: {
            type: Object,
            default: () => {
                return {
                    heading: 'Accordion Heading',
                    body: 'Accordion Body, Lorem ipsum'
                };
            }
        }
    },
    data() {
        return {
            // Icons
            plusIcon,
            minusIcon,
            showBody: true
        };
    }
};
